import {html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import defaultStyle from '../../../b2b-public-styles.scss';
import ExternalUser from '../../../../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUser.js';
import B2bPublicServiceClientProxy from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import '../email/b2b-public-email.js';
import RegistrationCredentials from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/utils/RegistrationCredentials.js';

@customElement('b2b-public-registration')
export class B2bPublicRegistration extends B2bElement {
  static styles = [defaultStyle];

  /** @type {ExternalUser} */
  @state()
  accessor __externalUser = new ExternalUser();

  /** @type {RegistrationCredentials} */
  @state()
  accessor __credentials = new RegistrationCredentials(this.__externalUser);

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  /**
   * @param {RegistrationCredentials} entry
   * @return {Promise<Boolean>}
   */
  __submit = entry => this.__b2bPublicServiceProxy.registerExternalUser(entry);

  render() {
    return html`
      <mta-page-title page-name="registration" title="SignUp"></mta-page-title>
      <div class="page-container">
        <mta-form
            class="registration-form"
            .value="${this.__credentials}"
            @success="${this.__submitted}"
            success-message="User registered successfully">
          <div class="menu-top-left">
            <common-mta-logo class="logo" url=""></common-mta-logo>
          </div>
          <div class="form-header">
            <h2>Sign up</h2>
          </div>
          <div class="input-group">
            <mta-form-input name="externalUser.firstname" label="Firstname" required></mta-form-input>
            <mta-form-input name="externalUser.lastname" label="Lastname" required></mta-form-input>
          </div>
          <div class="input-group">
            <mta-form-input name="externalUser.username" label="Username" required></mta-form-input>
            <mta-form-input name="externalUser.companyName" label="Company name" required></mta-form-input>
          </div>
            <mta-form-input name="externalUser.email" label="Email" required></mta-form-input>
            <mta-form-input name="externalUser.password" type="password" label="Password" required></mta-form-input>
            <mta-form-input name="confirmPassword" type="password" label="Confirm Password" required></mta-form-input>
          
          <mta-form-buttons hide-cancel="true" submit-label="Sign up" .submit="${this.__submit}"></mta-form-buttons>
          <div class="divider">
              <span>or</span>
          </div>
          <p class="login-link">Already have an account? <a href="#/auth/login">Log In</a></p>
        </mta-form>
      </div>
    `;
  }

  __submitted() {
    this.redirect('#/auth/email');
  }
}
